import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AiTextDialogComponent } from './ai-text-dialog.component';
import { FlexModule, GridModule } from '@angular/flex-layout';
import { QuillModule } from '@clients/shared';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslocoModule } from '@ngneat/transloco';
import { DragDropModule } from '@angular/cdk/drag-drop';



@NgModule({
  declarations: [AiTextDialogComponent],
  imports: [
    CommonModule,
    GridModule,
    QuillModule,
    ReactiveFormsModule,
    FlexModule,
    MatButtonModule,
    MatDialogModule,
    TranslocoModule,
    DragDropModule,
  ],
  exports: [AiTextDialogComponent],
})
export class AiTextDialogModule {}
